<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2">
      <div v-if="object && object[property]">
        <b-link :href="getValue(property)" target="_blank">{{textBefore}} {{getValue(property)}} {{textAfter}}</b-link>
      </div>
      <div v-else>-</div>
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowLinkValueField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    textBefore: {
      type: String,
      default: ''
    },
    textAfter: {
      type: String,
      default: ''
    }
  },

  computed: {
    getValue () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? this.object[property] : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowLinkValueField.vue